function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import React from "react";
import PropTypes from "prop-types";
import { responsiveHeightType, responsiveMaxWidthType } from "../hooks/useResponsiveProp";
import useAllResponsiveProps from "../hooks/useAllResponsiveProps";
import { logoListMapping } from "./logo-list";
import { jsx as ___EmotionJSX } from "@emotion/core";
var NAMES = ["latitude", "gem"];
var COLORS = ["primary.blue.t100", "black", "white"];
var DEFAULT_PROPS = {};
Logo.NAMES = NAMES;
Logo.COLORS = COLORS;
Logo.DEFAULT_PROPS = DEFAULT_PROPS;

function Logo(_props) {
  var props = _objectSpread(_objectSpread({}, DEFAULT_PROPS), _props);

  var name = props.name,
      color = props.color,
      testId = props.testId;
  var heightProps = useAllResponsiveProps(props, "height");
  var maxWidthProps = useAllResponsiveProps(props, "maxWidth");

  if (!NAMES.includes(name)) {
    return null;
  }

  var LogoComponent = logoListMapping[name];

  var logoProps = _objectSpread(_objectSpread(_objectSpread({
    color: color
  }, heightProps), maxWidthProps), {}, {
    testId: testId
  });

  return ___EmotionJSX(LogoComponent, logoProps);
}

Logo.propTypes = _objectSpread(_objectSpread(_objectSpread({
  name: PropTypes.oneOf(NAMES).isRequired,
  color: PropTypes.oneOf(COLORS)
}, responsiveHeightType), responsiveMaxWidthType), {}, {
  testId: PropTypes.string
});
export default Logo;